import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CodaltComponent } from 'app/codalt.component';
import { Customer } from '../customer';
import { AuthService } from '../services/auth/auth.service';
import { CustomerService } from '../services/customer/customer.service';
import { PageTitleService } from '../services/page-title/page-title.service';
import { Settings } from '../settings.class';

@Component({
    selector: 'app-customer-detail',
    templateUrl: './customer-detail.component.html',
    styleUrls: ['./customer-detail.component.scss'],
    standalone: false,
})
export class CustomerDetailComponent extends CodaltComponent implements OnInit {
    childActive = false;
    customer: Customer;
    screenshot = false;
    child: any;
    childIsWorkarea = false;
    hideMap = false;

    constructor(
        private cdref: ChangeDetectorRef,
        private route: ActivatedRoute,
        private authService: AuthService,
        private customerService: CustomerService,
        private pageTitleService: PageTitleService,
        private router: Router
    ) {
        super();
    }

    childActivate() {
        this.childActive = true;
        this.cdref.detectChanges();
    }

    childDeactivate() {
        this.childActive = false;
        this.pageTitleService.setTitle('Klantgebied', this.customer?.customer_name);
        this.cdref.detectChanges();
    }

    childChanged(childComponent: Component) {
        this.childIsWorkarea = !!childComponent['isWorkareaComponent'];
        this.cdref.detectChanges();
    }

    ngOnInit() {
        this.pageTitleService.setTitle('Klantgebied');
        this.screenshot = this.route.pathFromRoot.some(
            route => route.snapshot.routeConfig?.path === this.Routenames.customersScreenshot
        );
        if (this.screenshot) {
            this.hideMap = ([this.Routenames.list, this.Routenames.table, this.Routenames.report] as string[]).includes(
                this.route.snapshot?.firstChild?.url[0]?.path
            );
            Settings.mapSettings = {
                show_cancelled: true,
                show_executed_month: true,
                show_executed_year: true,
                show_approved: true,
                show_own: false,
                largeMapTextShadow: false,
                hide_clusters: true,
            };
            document.body.classList.add('screenshot');
        }
        this.watchRouteParams(
            [this.RouteParamnames.customerId, this.RouteParamnames.token],
            ({ customerId, token }) => {
                if (token) {
                    this.LocalStorage.setUserToken(token);
                    this.authService.getUserDetails().subscribe(user => {
                        this.LocalStorage.setUser(user.data);
                        this.loadCustomer(+customerId);
                    });
                } else {
                    this.loadCustomer(+customerId);
                }
            }
        );
    }

    loadCustomer(id) {
        this.subscriptions.add(
            this.customerService.getSingle(id).subscribe({
                next: customer => {
                    this.customer = customer;
                    this.LocalStorage.setCustomer(customer);
                    this.pageTitleService.setTitle('Klantgebied', customer.customer_name);
                },
                error: () => {
                    this.router.navigate([this.Routenames.customers], { replaceUrl: true });
                },
            })
        );
    }
}
